var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { attrs: { gutter: 20 } },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "div",
          { staticClass: "avatar-container" },
          [
            _c("el-image", {
              attrs: {
                src: _vm.memberInfo.avatar,
                "preview-src-list": [_vm.memberInfo.avatar],
                fit: "cover",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-descriptions",
            {
              attrs: {
                "label-style": { fontWeight: 600 },
                column: _vm.device === "mobile" ? 1 : 2,
                colon: false,
                size: "medium",
                border: "",
              },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.memberInfo.id)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "昵称" } }, [
                _vm._v(_vm._s(_vm.memberInfo.nickName)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                _vm._v(_vm._s(_vm.memberInfo.mobile)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "分享码" } }, [
                _vm._v(_vm._s(_vm.memberInfo.shareCode)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "邀请人" } }, [
                _vm._v(_vm._s(_vm.memberInfo.inviterName)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "邀请码" } }, [
                _vm._v(_vm._s(_vm.memberInfo.inviteCode)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "身份等级" } }, [
                _vm._v(_vm._s(_vm.memberInfo.gradeName)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "消费等级" } }, [
                _vm._v(_vm._s(_vm.memberInfo.consumerName)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "绑定状态" } }, [
                _vm._v(
                  _vm._s(
                    _vm.memberInfo.bindingStatus === 1 ? "已绑定" : "未绑定"
                  )
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "绑定位置" } }, [
                _vm._v(_vm._s(_vm.memberInfo.bindingLocation)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "成为粉丝时间" } }, [
                _vm._v(_vm._s(_vm.memberInfo.fansDate)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "成为会员时间" } }, [
                _vm._v(_vm._s(_vm.memberInfo.memberDate)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "成为SVIP时间" } }, [
                _vm._v(_vm._s(_vm.memberInfo.serviceDate)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "拥有分享收益时间" } },
                [_vm._v(_vm._s(_vm.memberInfo.privilegeDate))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "成为消费者时间" } },
                [_vm._v(_vm._s(_vm.memberInfo.consumerDate))]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "成为消费商时间" } },
                [_vm._v(_vm._s(_vm.memberInfo.retailerDate))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }